import React from "react";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import { useTranslation } from "react-i18next";

const AlertsCollection = ({
	requestAlert,
	setRequestAlert,
	evaluateTemplateAlert,
	setEvaluateTemplateAlert,
	requestChkAlert,
	setRequestChkAlert,
	requestAcceptAlert,
	setRequestAcceptAlert,
	judgeNumberMaxFive,
	setJudgeNumberMaxFive,
	submitEvalRequest,
	confirmFinish,
}) => {
	const { t } = useTranslation();
	return (
		<>
			{/*첫번째 카드 - 다음 버튼 클릭시 - 요청 내용 없음*/}
			<AlertTemplate
				alertModalState={requestAlert}
				setAlertModalToggle={setRequestAlert}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.alert01")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setRequestAlert(false)}
					>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.confirm")}
					</button>
				</div>
			</AlertTemplate>

			{/*첫번째 카드 - 다음 버튼 클릭시 - 심사항목 설정 없음*/}
			<AlertTemplate
				alertModalState={evaluateTemplateAlert}
				setAlertModalToggle={setEvaluateTemplateAlert}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.warning")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setEvaluateTemplateAlert(false)}
					>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.confirm")}
					</button>
				</div>
			</AlertTemplate>

			{/*두번째 카드 - 5명 이상 Negative to proceed */}
			<AlertTemplate
				alertModalState={judgeNumberMaxFive}
				setAlertModalToggle={setJudgeNumberMaxFive}
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.alert02")}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setJudgeNumberMaxFive(false)}
					>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.confirm")}
					</button>
				</div>
			</AlertTemplate>

			{/*심사요청 버튼 클릭시 AlertModal*/}
			<AlertTemplate
				alertModalState={requestChkAlert}
				setAlertModalToggle={setRequestChkAlert}
				className="request-chk-modal"
				alertType="warning"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.alert03")}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={submitEvalRequest}>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.button01")}
					</button>
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setRequestChkAlert(false)}
					>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.button02")}
					</button>
				</div>
			</AlertTemplate>

			{/*심사요청 모달에서 "예"버튼 클릭시 AlertModal*/}
			<AlertTemplate
				alertModalState={requestAcceptAlert}
				setAlertModalToggle={setRequestAcceptAlert}
				alertType="success"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.alert04")}
					</div>
				</p>
				<div className="alert-footer">
					<button className="btn__solid" color="primary" onClick={() => confirmFinish()}>
						{t("pages.investment.InvestEvalPage.evalRequest.AlertsCollection.confirm")}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default AlertsCollection;
